module.exports = __webpack_public_path__ + "img/4.3e91127a.jpeg";